//@ts-nocheck
import { Component } from "react";
import { Provider } from "react-redux";
import { OidcProvider } from "redux-oidc";

import store from "@store/index.ts";
import Routes from "@components/routes";
import userManager from "@utils/userManager";
import * as Sentry from "@sentry/browser";

import { ThemeProvider } from "@emotion/react";
import emotionTheme from "@config/emotionTheme";

import "moment/min/moment-with-locales";
import "moment/locale/pt-br";
import moment from "moment";
import Browser from "@utils/Browser";

class App extends Component {
  constructor(props) {
    super(props);
    moment.locale("pt-br");

    Sentry.init({
      dsn: "https://7fbbea1bf2a34718b56323132a2f47e8@sentry.io/1288032",
    });

    Browser.validate();
  }

  componentDidCatch(error, errorInfo) {
    Sentry.configureScope((scope) => {
      Object.keys(errorInfo).forEach((key) => {
        scope.setExtra(key, errorInfo[key]);
      });
    });
    Sentry.captureException(error);
  }

  render() {
    return (
      <Provider store={store}>
        <OidcProvider store={store} userManager={userManager}>
          <ThemeProvider theme={emotionTheme}>
            <Routes />
          </ThemeProvider>
        </OidcProvider>
      </Provider>
    );
  }
}

export default App;
